<!--
 * @Author: hchao
 * @Date: 2023-04-24 09:20:15
 * @Version: 1.0
 * @Description: 
-->
<template>
  <div class="banner">
    <img :src="bannerPic" alt="" style="width:100%">
    <div class="banner-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {downloadFile} from "@/utils/indexUrl";
import { previewFile } from "@/utils/utils.js"
export default {
  data() {
    return {
      bannerPic: '',
      bannerHeight: ''
    };
  },
  props: {
    outBannerHeight: { // banner高度
      type: String
    },
    bannerAttachPath: { // banner附件地址
      type: String
    },
    defaultBanner: { // 默认banner图
      type: String
    }
  },
  watch: {
    bannerAttachPath: {
      handler() {
        this._downloadAttachFile()
      },
      immediate: true
    }
  },
  methods: {
    getBannerHeight() {
      let clientWidth = document.documentElement.clientWidth > 1200 ? document.documentElement.clientWidth : 1200
      this.bannerHeight = clientWidth / 1920 * parseInt(this.outBannerHeight) + 'px'
    },
    _downloadAttachFile() {
      if (!this.bannerAttachPath) return false
      previewFile(this.bannerAttachPath).then(res => {
        this.bannerPic = res;
      })
    },
  },
  created() {
    // 处理banner图片
    this.bannerPic = this.defaultBanner

  },
  mounted() {
    // 处理banner图片高度
    // this.bannerHeight = this.outBannerHeight
    // this.getBannerHeight()
    // window.addEventListener('resize', this.getBannerHeight)
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.getBannerHeight)
  }
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  .banner-content{
    position: absolute;
    top: 60px;
    left: 50%;
    margin-left: -600px;
  }
}
</style>
